export default __webpack_public_path__ + "static/media/cs-a018-4.c8ac2e94.svg";